import Promise from 'promise-polyfill';

import {
  SET_MEDIA_LINKS,
  UPDATE_MEDIA_LINKS,
  SET_MEDIA_LINKS_LOADING,
  MAX_LINKS_COUNT_FETCH,
} from '../../constants';

import {
  getInstagramMediasSettings,
  getInstagramMediaLinks,
  getDemoInstagramMediaLinks,
} from '../api/linksApi';
import { createLinksPromiseArray, buildMap } from './serviceUtils';

import store from '../../store';

import { temlatesBusinessInstanceId } from '../templates/templatesConfig.json';

/**
 * Get links of medias, happened when:
 * connection - done
 * media updated (load more etc...) - done
 * links modal closed - done
 * In case of too many links - seperates the call in two
 */
export const getMediasLinksCount = (newMedias, isTemplate) => (dispatch) => {
  let { medias, isConnected, templateId } = store.getState().appReducer;
  medias = newMedias ? newMedias : medias;
  if (medias && medias.length > 0) {
    const isMultipleCalls = medias.length > MAX_LINKS_COUNT_FETCH;

    const mediasIds = medias
      .map((media) => {
        return media.originalData.id;
      })
      .join(',');
    const mediasLinks = medias
      .map((media) => {
        return media.originalData.permalink;
      })
      .join(',');

    const promiseLinksArray = createLinksPromiseArray(
      isMultipleCalls,
      mediasIds,
      mediasLinks,
      isTemplate,
      templateId,
    );
    return Promise.allSettled(promiseLinksArray).then((response) => {
      const totalLinks = response.reduce(
        (acc, el) => ({ ...acc, ...el.value.data }),
        {},
      );
      let { mediaLinksMap } = store.getState().appReducer;
      const map = buildMap(totalLinks);
      mediaLinksMap = mediaLinksMap
        ? new Map([...mediaLinksMap, ...map])
        : new Map(map);

      dispatch({
        type: UPDATE_MEDIA_LINKS,
        payload: mediaLinksMap,
      });
    });
  }
};

/**
 * Get link settings (add user data to DB)
 * @param {*} accountType
 */
export const getLinksSettings = (accountType) => (dispatch) => {
  return getInstagramMediasSettings(accountType)
    .then((res) => res)
    .catch((err) => err);
};

const _setCorrectDefaultLinkImg = (product) => {
  const images = {
    defaultImage: require('../../../assets/expand/default_wix_img.png'),
    defaultPageImage: require('../../../assets/expand/default_wix_img_page.png'),
  };
  switch (product.type) {
    case 'product': {
      product.image_url = images.defaultImage;
      break;
    }
    case 'site_page': {
      product.image_url = images.defaultPageImage;
      break;
    }
    default: {
      product.image_url = images.defaultImage;
    }
  }
  return product;
};

export const getMediaLinks = (
  dispatch,
  mediaIdsArr,
  mediaLinksArr,
  accessToken,
  userId,
  isBusinessApp,
  isConnected,
  newIndex,
  onFirstLoad,
) => {
  if (!isConnected && !accessToken && !userId) {
    const { user } = store.getState().appReducer;
    const demoAccountId = user.id;
    const templateObj = [];
    if (temlatesBusinessInstanceId.includes(demoAccountId)) {
      getDemoInstagramMediaLinks(demoAccountId).then((result) => {
        for (const media of result['product_links']) {
          templateObj[media.media_id] = result.product_links;
        }
        dispatch({
          type: SET_MEDIA_LINKS,
          payload: templateObj,
        });
        dispatch({
          type: SET_MEDIA_LINKS_LOADING,
          payload: true,
        });
        return templateObj;
      });
    }
    dispatch({
      type: SET_MEDIA_LINKS,
      payload: templateObj,
    });
    dispatch({
      type: SET_MEDIA_LINKS_LOADING,
      payload: true,
    });
    return templateObj;
  } else {
    dispatch({
      type: SET_MEDIA_LINKS_LOADING,
      payload: false,
    });
    // Getting the current link before
    if (onFirstLoad) {
      getInstagramMediaLinks(
        mediaIdsArr[newIndex],
        mediaLinksArr[newIndex],
        accessToken,
        userId,
        isBusinessApp,
        isConnected,
      ).then((result) => {
        const currentLinkObject = getLinksForPosts(result);
        dispatch({
          type: SET_MEDIA_LINKS,
          payload: currentLinkObject,
        });
      });
    }

    const getMediaLinksArr = [];
    for (let i = 0; i < mediaIdsArr.length; i++) {
      getMediaLinksArr.push(
        getInstagramMediaLinks(
          mediaIdsArr[i],
          mediaLinksArr[i],
          accessToken,
          userId,
          isBusinessApp,
          isConnected,
        ),
      );
    }

    Promise.allSettled(getMediaLinksArr).then((resultsArray) => {
      const linksObject = getLinksForPosts(resultsArray);
      dispatch({
        type: SET_MEDIA_LINKS,
        payload: linksObject,
      });
      dispatch({
        type: SET_MEDIA_LINKS_LOADING,
        payload: true,
      });
    });
  }
};

function getLinksForPosts(results) {
  results = Array.isArray(results) ? results : [results];
  const productLinksObj = [];
  for (let linksEl of results) {
    if (!linksEl.value) linksEl = { value: linksEl };
    let {
      value: { product_links, media_id },
    } = linksEl;
    product_links = product_links.map((product) => {
      if (product.image_url) {
        product.image_url = product.image_url.replace(
          'w_50,h_50',
          'w_100,h_100',
        );
        product.image_url = product.image_url.replace(
          'w_60,h_60',
          'w_100,h_100',
        );
        product.defaultImage = false;
      }
      if (!product.image_url) {
        _setCorrectDefaultLinkImg(product);
        product.defaultImage = true;
      }
      return product;
    });
    productLinksObj[media_id] = product_links;
  }
  return productLinksObj;
}
